'use strict';

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./cjs/value-equal.min.js');
} else {
  module.exports = require('./cjs/value-equal.js');
}



//////////////////
// WEBPACK FOOTER
// ./~/value-equal/index.js
// module id = 1554
// module chunks = 0